import {
  ADD_LOADING,
  MATERIAL_FAILURE,
  MATERIAL_SUCCESS,
  GET_MATERIAL,
  GET_STORE_SUCCESS,
  GET_STORE_FAILURE,  
  GET_EQUIPMENT_SUCCESS,
  GET_EQUIPMENT_FAILURE,
  GET_LABOUR_SUCCESS,
  GET_LABOUR_FAILURE,
  GET_LABOURFORCE_SUCCESS,
  GET_LABOURFORCE_FAILURE,
  ISSUE_HISTORY_SUCCESS,
  ISSUE_HISTORY_ERROR,
  ADD_ISSUE,
  ADD_ISSUE_HISTORY_LOADING,
  MATERIALS_LIST_SUCCESS,
  MATERIALS_LIST_FAILURE,
  MATERIALS_LIST_LOADING,
  EQUIPMENTS_LIST_FAILURE,
  EQUIPMENTS_LIST_SUCCESS,
  EQUIPMENTS_LIST_LOADING,
  LABOUR_LIST_FAILURE,
  LABOUR_LIST_SUCCESS,
  LABOUR_LIST_LOADING,
  LABOURFORCE_LIST_FAILURE,
  LABOURFORCE_LIST_LOADING,
  LABOURFORCE_LIST_SUCCESS,
  ADD_MATERIAL_REQ,
  MATERIAL_REQ_LOADING,
  MATERIAL_REQ_SUCCESS,
  MATERIAL_REQ_ERROR,
  REJECT_MATERIAL_REQ,
} from "./storeActionTypes";

const initialState = {
  data: [],
  storeData: [],
  equipmentData:[],
  contractorRAData:[],
  manpowerData:[],
  success: false,
  loading: false,
  getStoreLoading: false,
  getStoreSuccess: false,
  getStoreError: false,
  error: "",
  issueLoading: false,
  issueHistory: [],
  issueError: false,
  materials: [],
  equipments:[],
  labours:[],
  labourforce:[],
  materialListLoading: false,
  materialListSuccess: false,
  materialListFailure: false,
  equipmentListLoading: false,
  equipmentListSuccess: false,
  equipmentListFailure: false,
  labourListLoading: false,
  labourListSuccess: false,
  labourListFailure: false,
  labourforceListLoading: false,
  labourforceListSuccess: false,
  labourforceListFailure: false,
  materialReqLoading: false,
  materialReqError: false,
  materialReqIssues: [],
};

export const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LOADING:
      return {
        ...state,
        getStoreLoading: true,
      };
    case GET_MATERIAL:
      return {
        ...state,
        data: action.payload,
      };
    case GET_STORE_SUCCESS:
      return {
        ...state,
        storeData: action.payload,
        getStoreLoading: false,
        getStoreSuccess: true,
      };
    case GET_STORE_FAILURE:
      return {
        ...state,
        getStoreLoading: false,
        error: action.payload,
        getStoreError: true,
      };
      case GET_EQUIPMENT_SUCCESS:
      return {
        ...state,
        equipmentData: action.payload,
        getStoreLoading: false,
        getStoreSuccess: true,
      };
    case GET_EQUIPMENT_FAILURE:
      return {
        ...state,
        getStoreLoading: false,
        error: action.payload,
        getStoreError: true,
      };
      case GET_LABOUR_SUCCESS:
      return {
        ...state,
        contractorRAData: action.payload,
        getStoreLoading: false,
        getStoreSuccess: true,
      };
    case GET_LABOUR_FAILURE:
      return {
        ...state,
        getStoreLoading: false,
        error: action.payload,
        getStoreError: true,
      };
      case GET_LABOURFORCE_SUCCESS:
      return {
        ...state,
        manpowerData: action.payload,
        getStoreLoading: false,
        getStoreSuccess: true,
      };
    case GET_LABOURFORCE_FAILURE:
      return {
        ...state,
        getStoreLoading: false,
        error: action.payload,
        getStoreError: true,
      };
    case MATERIAL_SUCCESS:
      return {
        ...state,
        success: true,
        getStoreLoading: false,
        loading: false,
      };
    case MATERIAL_FAILURE:
      return {
        ...state,
        data: action.payload,
        success: false,
        getStoreLoading: false,
        loading: false,
      };
    case ADD_ISSUE:
      return {
        ...state,
        getStoreLoading: false,
        loading: false,
      };

    case ADD_ISSUE_HISTORY_LOADING: {
      return {
        ...state,
        issueLoading: true,
      };
    }

    case ISSUE_HISTORY_SUCCESS:
      return {
        ...state,
        issueLoading: false,
        issueHistory: action.payload,
        issueError: false,
      };
    case ISSUE_HISTORY_ERROR:
      return {
        ...state,
        issueLoading: false,
        issueError: true,
      };
    case MATERIALS_LIST_LOADING:
      return { ...state, materialListLoading: true };
    case MATERIALS_LIST_SUCCESS: {
      return {
        ...state,
        materials: action.payload,
        materialListLoading: false,
        materialListSuccess: true,
      };
    }
    case MATERIALS_LIST_FAILURE: {
      return {
        ...state,
        materialListFailure: true,
        materialListLoading: false,
        materialListError: action.error,
      };
    }
    case EQUIPMENTS_LIST_LOADING:
      return { ...state, equipmentListLoading: true };
    case EQUIPMENTS_LIST_SUCCESS: {
      return {
        ...state,
        equipments: action.payload,
        equipmentListLoading: false,
        equipmentListSuccess: true,
      };
    }
    case EQUIPMENTS_LIST_FAILURE: {
      return {
        ...state,
        equipmentListFailure: true,
        equipmentListLoading: false,
        equipmentListError: action.error,
      };
    }
    case LABOUR_LIST_LOADING:
      return { ...state, labourListLoading: true };
    case LABOUR_LIST_SUCCESS: {
      return {
        ...state,
        labours: action.payload,
        labourListLoading: false,
        labourListSuccess: true,
      };
    }
    case LABOUR_LIST_FAILURE: {
      return {
        ...state,
        labourListFailure: true,
        labourListLoading: false,
        labourListError: action.error,
      };
    }
    case LABOURFORCE_LIST_LOADING:
      return { ...state, labourforceListLoading: true };
    case LABOURFORCE_LIST_SUCCESS: {
      return {
        ...state,
        labourforce: action.payload,
        labourforceListLoading: false,
        labourforceListSuccess: true,
      };
    }
    case LABOURFORCE_LIST_FAILURE: {
      return {
        ...state,
        labourforceListFailure: true,
        labourforceListLoading: false,
        labourforceListError: action.error,
      };
    }
    case ADD_MATERIAL_REQ:
      return {
        ...state,
        getStoreLoading: false,
        loading: false,
      };

    case MATERIAL_REQ_LOADING: {
      return {
        ...state,
        materialReqLoading: true,
      };
    }

    case MATERIAL_REQ_SUCCESS:
      return {
        ...state,
        materialReqLoading: false,
        materialReqIssues: action.payload,
        materialReqError: false,
      };
    case MATERIAL_REQ_ERROR:
      return {
        ...state,
        materialReqLoading: false,
        materialReqError: true,
      };
    case REJECT_MATERIAL_REQ:
      return {
        ...state,
        getStoreLoading: false,
        loading: false,
      };

    default:
      return state;
  }
};
